module.exports = __webpack_public_path__ + "img/otcbg.1e09b029.jpg";